import { CircularProgress, Box } from "@mui/material";
import React, { useContext } from "react";

import { SessionContext } from "../../../utility/useSession";
import { getTimeSlotDateStateColours } from "./KmosView";

import styles from "./KmosView.module.css";
import { useTranslation } from "react-i18next";

const KmosDialogTotals: React.FunctionComponent<{
  capacity: number | undefined;
  dueInTotal: number | undefined;
  dueIn: number | undefined;
  hasAllocations: boolean;
}> = (props) => {
  const { capacity, dueInTotal, dueIn, hasAllocations } = props;
  const { t } = useTranslation();

  const session = useContext(SessionContext);
  const lookAheadHours = session.current.site?.preferences.kmos_duein_hours_ahead || 48;

  const [backgroundColour, textColour] = getTimeSlotDateStateColours(
    capacity || 0,
    dueIn || 0,
    hasAllocations
  );

  const totalDisplay = (value: number | undefined, caption: string) => {
    return (
      <div
        className={styles.dialogTotalDisplay}
        style={{ backgroundColor: backgroundColour, color: textColour }}
      >
        <div className={styles.dialogTotalValue}>
          {typeof value === "undefined" ? (
            <CircularProgress style={{ color: "#fff" }} />
          ) : (
            value
          )}
        </div>
        <div className={styles.dialogTotalCaption}>{caption}</div>
      </div>
    );
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {totalDisplay(dueIn, t("kmos.labels.dueInHours", { time: lookAheadHours }))}
      {totalDisplay(dueInTotal, t("kmos.labels.dueInTotal"))}
      {totalDisplay(capacity, t("kmos.labels.spaces"))}
    </Box>
  );
};

export default KmosDialogTotals;
